/* eslint no-unused-expressions: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'emotion-theming';
import { theme } from '../../config/theme';
import SEO from '../components/SEO';
import Navigation from '../components/Navigation';
import Body from './Body';
import { setTheme } from '../components/OrbContainer';

import { injectGlobal } from 'emotion';
import { CssGlobal } from './CssGlobal';

injectGlobal`${theme.cssGlobal}`;

const MainLayout = ({ children }) => (
  <ThemeProvider theme={theme}>
    <React.Fragment>
      <SEO />
      <Body onLoad={setTheme()}>
        <Navigation />
        {children()}
      </Body>
    </React.Fragment>
  </ThemeProvider>
);

export default MainLayout;

MainLayout.propTypes = {
  children: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/layouts/index.jsx